interface AdmissionPlaceholderDragEndProps {
  height?: number;
}

export const AdmissionPlaceholderDragEnd = ({ height = 100 }: AdmissionPlaceholderDragEndProps) => {
  return (
    <div className='bg-tertiary border-2 border-dashed border-medium rounded-lg' style={{ height: `${height}px` }} />
  );
};
